import React from "react";
import {
  House,
  ShieldCheck,
  BookmarkSimple,
  Gear,
} from "@phosphor-icons/react";

/**
 * Bottom tab navigation for TipLingo v2.
 *
 * Tabs: Home / Vault / Saved / Settings.
 * Active state uses Orange (#E55B2C) for icon + label.
 * Fixed to bottom of the viewport with safe-area padding.
 */
const TABS = [
  { id: "home", label: "Home", Icon: House },
  { id: "vault", label: "Vault", Icon: ShieldCheck },
  { id: "saved", label: "Saved", Icon: BookmarkSimple },
  { id: "settings", label: "Settings", Icon: Gear },
];

export default function BottomNav({ tab, onChange }) {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-30 bg-white/95 backdrop-blur-xl border-t border-navy/10 pt-2"
      style={{ paddingBottom: "max(0.5rem, env(safe-area-inset-bottom))" }}
    >
      <div className="grid grid-cols-4 px-2">
        {TABS.map(({ id, label, Icon }) => {
          const active = tab === id;
          return (
            <button
              key={id}
              data-testid={`tab-${id}`}
              onClick={() => onChange(id)}
              className="flex flex-col items-center justify-center gap-1 py-2 px-1 transition-colors group"
              aria-label={label}
              aria-pressed={active}
            >
              <Icon
                size={26}
                weight={active ? "fill" : "duotone"}
                color={active ? "#E55B2C" : "#4A5D78"}
              />
              <span
                className={`text-xs font-semibold tracking-tight ${
                  active ? "text-orange" : "text-navy-soft"
                }`}
              >
                {label}
              </span>
              {active && (
                <span className="h-0.5 w-6 rounded-full bg-orange -mt-0.5" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
